<ds-checkbox
  [name]="name"
  [label]="label"
  [checked]="checked"
  (dsCheckboxChange)="onCheckboxChange($event)"
></ds-checkbox>
